/**
 * Lets a keyboard user jump past the navigation.
 *
 * <h2>Why the first thing on the page is a link most people never see</h2>
 *
 * Every page repeats the same navigation. Somebody tabbing through has to pass
 * all of it to reach the content, on every page, every time. This is the standard
 * answer: hidden until focused, and the first thing in the tab order.
 *
 * <p>It targets `#main`, which the application layout puts on its `main` element.
 */
export function SkipToContent() {
  return (
    <a
      href="#main"
      className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded-lg focus:bg-[var(--color-accent)] focus:px-4 focus:py-2 focus:font-semibold focus:text-white"
    >
      Skip to content
    </a>
  );
}
